import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  messageSocket: {}
}

const mutations = {
  getMessageSocket (state, data) {
    state.messageSocket = data
  },

}

export default new Vuex.Store({
  state,
  mutations
})



// WEBPACK FOOTER //
// ./src/store.js